// =============================================================================
// ResiGen — residential PV + ESS prepayment generator for external Dealers / Sales Affiliates.
// The valuation tables + calculation live in resigenTables.ts (Meteor-free); this module holds the
// persisted project collection and method declarations. Tables are PER ORG (negotiated per installer,
// Luminia defaults otherwise); projects snapshot the resolved calc so renegotiation never drifts quotes.
// =============================================================================

import { Mongo } from 'meteor/mongo';
import { Doc } from '/imports/types';
import { DeclareMethod } from '/imports/methods';
import { ResigenCalcResult, ResigenTables } from '/imports/api/resigenTables';

export * from '/imports/api/resigenTables';

// --- The persisted project ---

export interface ResigenProject extends Doc {
  orgId: string;
  name: string;
  address?: string;
  lat?: number;
  lng?: number;
  systemSizeKw: number;
  essCapacityKwh: number;
  energyCommunity?: boolean;
  disadvantagedCommunity?: boolean;
  // Snapshot of the calculation at last save — renegotiated org tables never drift an issued quote.
  calc: ResigenCalcResult;
}

export const ResigenProjects = new Mongo.Collection<ResigenProject>('resigenProjects');

export interface ResigenSaveArg {
  _id?: string;
  name: string;
  address?: string;
  lat?: number;
  lng?: number;
  systemSizeKw: number;
  essCapacityKwh: number;
  energyCommunity?: boolean;
  disadvantagedCommunity?: boolean;
}

// Roof-based size suggestion for the intake (Google Solar API): max system size for the address.
export const resigenRoofEstimate = DeclareMethod<{ lat: number, lng: number }, { maxKwDc?: number, maxPanels?: number, sqft?: number, existingSolar?: boolean } | null>('resigenRoofEstimate');
export const resigenSaveProject = DeclareMethod<ResigenSaveArg, string>('resigenSaveProject');
export const resigenDeleteProject = DeclareMethod<{ _id: string }>('resigenDeleteProject');
// The org's effective tables (own or defaults) — feeds the live intake preview and the view page.
export const resigenGetTables = DeclareMethod<void, ResigenTables>('resigenGetTables');
// Back office (super user): replace an org's tables (undefined → revert to the Luminia defaults).
export const resigenSaveOrgTables = DeclareMethod<{ orgId: string, tables?: ResigenTables }>('resigenSaveOrgTables');
